import fetch from '@/utils/fetch'
import { getStsToken, getWebSdkSignature } from './urls'
import { AxiosResponse } from 'axios'

/**
 * @name: getToken 阿里云
 * @param {type}
 * @return: Promise<AxiosResponse>
 */
export default function getToken(data: any): Promise<AxiosResponse> {
  return fetch.post(getStsToken, data)
}

/**
 * @name: 获取腾讯云视频上传
 * @param {type}
 * @return: Promise<AxiosResponse>
 */
export function getVideoSignature(data: any): Promise<AxiosResponse> {
  return fetch.get(getWebSdkSignature, { params: data })
}
